var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { memo } from 'react';
import useStyles from './styles';
var SwaySpinner = function (_a) {
    var _b = _a.withLogo, withLogo = _b === void 0 ? true : _b, _c = _a.classes, classes = _c === void 0 ? {} : _c;
    var styles = useStyles();
    return (_jsx("div", __assign({ className: clsx(styles.spinnerWrapper, classes.spinnerWrapper) }, { children: _jsxs("div", __assign({ className: styles.ballContainer }, { children: [_jsx("div", { className: clsx(styles.ball, classes.icon) }), _jsx("div", { className: styles.shadow }), withLogo ? _jsx("div", { className: styles.logo }) : null] })) })));
};
export default memo(SwaySpinner);
//# sourceMappingURL=index.js.map